import * as React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';
import Grid from 'ha/ui/next/Grid';
import units from 'ha/theme/units';

const styles = createStyles({
  fullHeight: {
    minHeight: units.vh(100),
  },
  grow: {
    flexGrow: 1,
  },
});

const StickyFooter: React.SFC<WithStyles<typeof styles>> = ({
  children,
  classes,
}) => (
  <Grid
    className={classes.fullHeight}
    direction="column"
    wrap="nowrap"
    container
  >
    <div className={classes.grow}>{children}</div>
  </Grid>
);

export default withStyles(styles)(StickyFooter);
